import type React from "react";

import { Flex, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { StyledCardSubHeadingText } from "app/pages/sales-intelligence/pages/company-analysis/containers/overview/DigitalAssetsCard/styles";

export const EmptyState: React.FC = () => {
    return (
        <Flex
            height="366px"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <Text fontVariant="h3">&lt;100</Text>
            <StyledCardSubHeadingText fontVariant="report">
                {translate("si.company-analysis.digital-assets-card.title")}
            </StyledCardSubHeadingText>
        </Flex>
    );
};
